<template>
  <div class="up_evaluate">
    <div class="evaluate">
      <div class="flex evaluate_title">
        <div>商品评价</div>
        <van-rate color="#EE0A24" class="margin" v-model="goods_score" />
        <div class="color">{{rateText[goods_score-1]}}</div>
      </div>
      <div class="content">
        <van-field
          v-model="content"
          maxlength="150"
          rows="6"
          label
          type="textarea"
          show-word-limit
          placeholder="请填写评价…"
        />
        <div class="up_image flex">
          <van-uploader v-model="fileList" multiple :max-count="5" :after-read="afterRead">
            <div class="up_data">
              <img :src="imgPath + 'shopUpImage1104.png'" alt />
              <div>添加图片</div>
            </div>
          </van-uploader>
        </div>
      </div>
    </div>

    <div class="service">
      <div class="service_title">服务评价</div>
      <div class="flex evaluate_title">
        <div>物流评价</div>
        <van-rate class="margin" color="#EE0A24" v-model="logistics_score" />
        <div class="color">{{rateText[logistics_score-1]}}</div>
      </div>
    </div>
    <div class="ben" @click="uplade">提交</div>
    <van-overlay :show="isLoading" @click="isLoading = false">
      <div class="wrapper" @click.stop>
        <van-loading type="spinner" text-color="#0094ff" />
      </div>
    </van-overlay>
  </div>
</template>


<script>
import Vue from 'vue'
import { Rate, Field, Toast } from 'vant'

Vue.use(Rate)
Vue.use(Field)
export default {
  data() {
    return {
      content: '',
      goods_score: 5,
      logistics_score: 5,
      rateText: ['很差', '差', '中等', '好', '很好'],
      fileList: [],
      images: [],
      isLoading: false,
    }
  },
  methods: {
    afterRead(file) {
      console.log(file)
      console.log(this.fileList)
    },
    // 上传
    async updataImg(item) {
      console.log(item)
      let res = await this.Oss.uploadFile('refund/' + item.file.name, item.file)
      console.log(res)
      if (res.msg == 'ok') {
        this.images.push(res.url)
        console.log('ok')
      } else {
        this.isLoading = false
      }
    },
    uplade() {
      this.isLoading = true
      if (this.fileList.length > 0) {
        this.fileList.forEach(async (item) => {
          if (item) {
            await this.updataImg(item)
          }
          if (this.fileList.length == this.images.length) {
            this.save()
          }
        })
      } else {
        this.save()
      }
    },
    async save() {
      let res = await this.http('ClientOrderEvaluate.addEvaluate', {
        order_detail_id: this.$route.query.id,
        goods_score: this.goods_score,
        logistics_score: this.logistics_score,
        content: this.content,
        image: this.images,
      })
      if (res.status == 200) {
        Toast('评价成功')
        this.isLoading = false
        setTimeout(() => {
          this.$router.go(-1)
        }, 500)
      } else {
        this.isLoading = false
        Toast(res.msg)
      }
      console.log(res)
    },
  },
}
</script>

<style>
.up_evaluate .van-cell {
  padding: 0;
}
.up_evaluate .van-cell::after {
  display: none;
}
</style>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.flex {
  display: flex;
  align-items: center;
}

.up_evaluate {
  background: #f7f8fa;
  border-top: 1px solid #f7f8fa;
  min-height: calc(100vh - 1px);

  font-size: 28px;
  font-weight: 400;
  color: #999999;
  .evaluate {
    margin-top: 20px;
    background: #fff;
    padding: 20px 0 20px;
    .content {
      padding: 0 40px 0;
      margin-top: 20px;
      .up_image {
        flex-wrap: wrap;
        .up_data {
          width: 200px;
          height: 200px;
          background: #f8f8f8;
          border-radius: 20px;
          font-size: 28px;
          font-weight: 400;
          color: #666666;
          text-align: center;
          overflow: hidden;
          margin-right: 20px;
          margin-bottom: 20px;
          img {
            width: 60px;
            height: 56px;
            display: block;
            margin: 50px auto 0;
          }
        }
        > img {
          width: 200px;
          height: 200px;
          margin-right: 20px;
          margin-bottom: 20px;
        }
      }
    }
  }
}

.service {
  margin-top: 20px;
  background: #fff;
  .service_title {
    height: 80px;
    border-bottom: 1px solid #f1f1f1;
    line-height: 80px;
    text-indent: 40px;
    color: #333333;
  }
  .evaluate_title {
    height: 120px;
  }
}

.evaluate_title {
  padding: 0 40px 20px;
  border-bottom: 1px solid #f1f1f1;
}
.color {
  color: #999999;
}

.margin {
  margin: 0 20px;
}
.ben {
  width: 686px;
  height: 96px;
  background: #ee0a24;
  border-radius: 48px;
  font-size: 32px;
  color: #ffffff;
  line-height: 96px;
  text-align: center;
  margin: 60px auto 0;
}
</style>